/* DataTable.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./DataTable.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { IconButton } from '@atlaskit/button/new';
import DynamicTable from '@atlaskit/dynamic-table';
import CloseIcon from '@atlaskit/icon/core/migration/close--editor-close';
import Modal, { ModalBody, ModalHeader } from '@atlaskit/modal-dialog';
import { element } from '../../core/elements';
import { Title } from '../title/title';
import { toSentenceCase } from '../utils/formatters';
import { a11yStrings } from '../utils/strings';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const gridStyles = null;
export const tableStyle = null;
function getHeaders(headers) {
  const cellHeaders = headers.map(header => ({
    key: header,
    content: toSentenceCase(header),
    isSortable: true
  }));
  return {
    cells: cellHeaders
  };
}
function getRows(data) {
  if (!data.length) {
    const keys = Object.keys(data);
    const rowData = keys.map(k => {
      var _data;
      const cellData = (_data = data[k]) === null || _data === void 0 ? void 0 : _data.toString();
      return {
        key: cellData,
        content: cellData
      };
    });
    return [{
      key: 'row-0',
      cells: rowData
    }];
  }
  const rows = data.map((d, i) => {
    const keys = Object.keys(d);
    const rowData = keys.map(k => {
      var _d$k;
      const cellData = (_d$k = d[k]) === null || _d$k === void 0 ? void 0 : _d$k.toString();
      return {
        key: cellData,
        content: cellData !== null && cellData !== void 0 ? cellData : '\u2014'
      };
    });
    return {
      key: `row-${i}`,
      cells: rowData
    };
  });
  return rows;
}
export function DataTableComponent(_ref) {
  let {
    data,
    headers: userDefinedHeaders
  } = _ref;
  if (!data || Array.isArray(data) && data.length === 0) {
    return null;
  }
  const headers = userDefinedHeaders ? getHeaders(userDefinedHeaders) : data && getHeaders(Object.keys(data[0]));
  const rows = getRows(data);
  return /*#__PURE__*/_jsx("div", {
    className: ax(["_n3tdu2gc _1reo1wug _18m91wug _ect41sbm _opvxu2gc _91ih131l _1ouib76v _cnoh1il0 _a2nzu2gc _9f9g1oud _slyj1fxt _1xc811bn"]),
    children: /*#__PURE__*/_jsx(DynamicTable, {
      head: headers,
      rows: rows,
      rowsPerPage: 10,
      defaultPage: 1,
      loadingSpinnerSize: "large"
    })
  });
}
export const DataTable = element(DataTableComponent);
export function DataTableModal(_ref2) {
  let {
    data,
    closeModal
  } = _ref2;
  return /*#__PURE__*/_jsxs(Modal, {
    onClose: closeModal,
    children: [/*#__PURE__*/_jsx(ModalHeader, {
      children: /*#__PURE__*/_jsxs("div", {
        className: ax(["_1bsb1osq _1e0c11p5 _zulppxbi _1lmcg5aa _yv0e1ghl _4cvr1h6o"]),
        children: [/*#__PURE__*/_jsx("div", {
          className: ax(["_1bahh9n0 _nd5l1bvj"]),
          children: /*#__PURE__*/_jsx(IconButton, {
            appearance: "subtle",
            icon: CloseIcon,
            label: a11yStrings.exitDataTable,
            onClick: closeModal
          })
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1bahv2br _nd5l1cy2"]),
          children: /*#__PURE__*/_jsx(Title, {})
        })]
      })
    }), /*#__PURE__*/_jsx(ModalBody, {
      children: /*#__PURE__*/_jsx(DataTable, {
        data: data
      })
    })]
  });
}